import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PaymentV2Service, UtilService, VwoService } from '../../shared/services';
import { IPaymentSipConfig } from '../payment-sip/payment-sip.model';

@Component({
  selector: 'app-payment-sip-net-banking',
  templateUrl: './payment-sip-net-banking.component.html',
  styleUrls: ['./payment-sip-net-banking.component.scss']
})
export class PaymentSipNetBankingComponent implements OnInit, OnChanges {

  @Input() config: IPaymentSipConfig;
  @Output() dataEmit = new EventEmitter();
  info = {
    bank: { placeholder: 'Select Bank', error: { pattern: 'Bank required' } },
    accountNo: { placeholder: 'Bank Account No.', error: { pattern: 'Invalid bank account number' } },
    ifsc: { placeholder: 'IFSC Code', error: { pattern: 'Invalid IFSC code' } }
  };
  bankForm: FormGroup = new FormGroup({
    bankCode: new FormControl('', [Validators.required]),
    accountNo: new FormControl('', [Validators.required, Validators.pattern(/^\d{9,18}$/)]),
    ifsc: new FormControl('', [Validators.required, Validators.pattern(/^[A-Za-z]{4}0[A-Z0-9a-z]{6}$/)]),
    searchBank: new FormControl(''),
  });

  bankList;
  oneTimeDonationBankList;

  constructor(
    private util: UtilService,
    public vwo: VwoService,
    private paymentV2: PaymentV2Service
  ) { }

  ngOnInit() {
    this.submitForm();
  }

  ngOnChanges(changes: SimpleChanges) {
    // tslint:disable-next-line: max-line-length
    if (changes.config && changes.config.currentValue && changes.config.currentValue.paymentOptions && changes.config.currentValue.paymentOptions.options.Emandate) {
      this.bankForm.addControl('accountNo', new FormControl('', [Validators.required, Validators.pattern(/^\d{9,18}$/)]));
      this.bankForm.addControl('ifsc', new FormControl('', [Validators.required, Validators.pattern(/^[A-Za-z]{4}0[A-Z0-9a-z]{6}$/)]));
    } else {
      this.bankForm.removeControl('accountNo');
      this.bankForm.removeControl('ifsc');
    }
  }

  submitForm() {
    this.paymentV2.pledgeBtn.subscribe(tab => {
      if (tab === 'bank') {
        if (this.bankForm.valid) {
          this.dataEmit.emit({
            mode: this.config.selectedTab.order_mode,
            mode_value: this.bankForm.get('bankCode').value,
            bank_account: this.bankForm.get('accountNo') ? this.bankForm.get('accountNo').value : '',
            bank_ifsc: this.bankForm.get('ifsc') ? this.bankForm.get('ifsc').value : '',
            bank_code: this.bankForm.get('bankCode').value,
            auth_mode: this.config.selectEmandateBank ? 'NET_BANKING' : 'DEBIT_CARD',
            bank_name: this.getSelectedBankName(this.bankForm.get('bankCode').value)
          });
        } else {
          this.util.checkValidForm(this.bankForm);
        }
      }
    });
  }

  search(value) {
    if (this.config.paymentOptions.options.Emandate) {
      if (!this.bankList) {
        this.bankList = this.config.paymentOptions.options.Emandate;
      }
      this.config.paymentOptions.options.Emandate = this.util.filterObject(this.bankList, value);
    } else {
      if (!this.oneTimeDonationBankList) {
        this.oneTimeDonationBankList = this.config.paymentOptions.options.NB;
      }
      this.config.paymentOptions.options.NB = this.util.filterObject(this.oneTimeDonationBankList, value);
    }
  }

  getSelectedBankName(code) {
    const bankList = this.config.paymentOptions.options.Emandate || this.config.paymentOptions.options.NB;
    return bankList[code];
  }

  resetSearch() {
    this.search('');
    this.bankForm.get('searchBank').setValue('');
  }

}
